import { useSecurityLevelControls } from "../hooks/useSecurityLevelControlData";
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../StateManagement/actions";
import TabLayout from "./TabLayout";
import { useContentSecurityControls } from "../hooks/useContentSecurityControlData";
import { useState } from "react";

export default function TabLayoutWrapper({ tabMenuText }) {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const settings = useSelector((state) => state.settings);
  const defaultSetting = useSelector((state) => state.settings.defaultSetting);
  const isDirectSend = tabMenuText === "DirectSendDefaults";
  
  const {getSecurityLevelControlData}=useSecurityLevelControls();
  const {getContentSecurityControlData}=useContentSecurityControls();

  const securityLevelControls = isDirectSend ? getSecurityLevelControlData(settings,defaultSetting) : [];
  const contentSecurityControls = !isDirectSend ? getContentSecurityControlData(settings) : [];
  
  

  const LevelControls = isDirectSend 
    ? { L1: [...securityLevelControls[0]] || [], L2: [...securityLevelControls[1]] || [], L3: [...securityLevelControls[2]] || [] }
    : {cipherText:[...contentSecurityControls[0]],floatingText:[...contentSecurityControls[1]]};
  
  return (
    <TabLayout 
      tabMenuText={tabMenuText} 
      controlData={LevelControls} 
    />
  );
}

